import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import Select from 'react-select';
import { returnStore } from '../../helpers/backend_helper';
import { getStorageCompany } from '../../helpers/api_helper';
import {Alert,ToastHelper} from '../../helpers/alerts/alertHelper';
import Validate from './Validate'

const ReturnModal = ({modal,setModal,item,authUser}) => {
	const company = getStorageCompany();
	const [returnItem, setReturnItem] = useState({
		id: 0,
		timer:'',
		salida_id:modal.id,
		time:modal.timeBase,
	});
	const [ errors, setErrors ] = useState([]);
	const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc',route_id:null,select:true});
	let params={params:filters}
	const [ selects, setSelects ] = useState({
		timers:[
			{label:'Tiempo 1',value:1},
			{label:'Tiempo 2',value:2},
			{label:'Tiempo 3',value:3},
			{label:'Tiempo 4',value:4},
			{label:'Tiempo 5',value:5},
			{label:'Tiempo 6',value:6},
			{label:'Tiempo 7',value:7},
			{label:'Tiempo 8',value:8},
			{label:'Tiempo 9',value:9}
			]
	});
	const [ loading, setLoading ] = useState(false);
	const handleClose = () => {
		setModal({...modal,show:false});
    }
 
    const handlerOnChange = (value,name) => {
    	setReturnItem({...returnItem, [name]:value});
    }

    const save = () => {
    	setErrors([])
    	setLoading(true)
    	console.log(returnItem)
    	returnStore(returnItem).then(response => {
    		setLoading(false)
    		setModal({...modal,show:false});
    	})

    }

    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-primary">Establecer regreso</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-sm-6">
						    <label className="form-label">¿Qué tiempo?:</label>
						    <Select
								className="basic-single"
								classNamePrefix="select"
								defaultValue={returnItem.timer}
								isClearable={false}
								isSearchable={false}
								name="color"
								options={selects.timers}
								onChange={ e => [handlerOnChange(e.value, 'timer')] }
							/>
						    {
						    	errors && <div className="form-text text-danger">{errors.timer && errors.timer[0]}</div>
						    }
						</div>
						<div className="col-sm-6">
						    <label className="form-label">Hora:</label>
						    <input className="form-control" placeholder='Hora' name="time" type="time" onChange={ e => handlerOnChange(e.target.value,'time') } value={returnItem.time}/>
						    
						    {
						    	errors && <div className="form-text text-danger">{errors.time && errors.time[0]}</div>
						    }
						</div>				
					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={save} disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } <i className='fa fa-save'></i> Guardar
					</Button>{' '}
					<Button color="secondary" onClick={handleClose}><i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default ReturnModal;